import http from './http' // needs this file in the same directory

export default {
  index(filter){
    return http.get(`/suppliers`);
  },

  show(item_id){
    return http.get(`/suppliers/`+item_id);
  },

  create(new_item){
    // delete new_item.contracts.data.litigations
    // new_item.contracts.data = new_item.contracts.data.filter(obj => obj.name)
    // new_item.litigations.data = new_item.litigations.data.filter(obj => obj.name)
    
    return http.post(`/suppliers`,{
      supplier:{ 
        name: new_item.name,
        document: new_item.document,
        email: new_item.email,
        addresses: new_item.addresses,
        corporate_info: new_item.corporate_info,
        bank_account: new_item.bank_account,
        phones: new_item.phones,
        comment: new_item.comment,
      }
    });
  },

  update(update_item){
    console.log({update_item});
    // delete update_item.contracts.data.litigations
    // update_item.contracts.data = update_item.contracts.data.filter(obj => obj.name)
    // update_item.litigations.data = update_item.litigations.data.filter(obj => obj.name) 

    return http.put(`/suppliers/${update_item.id}`,{
      supplier:{ 
        id: update_item.id,
        tag_list: update_item.tag_list.join(),
        name: update_item.name,
        document: update_item.document,
        
        email: update_item.email,
        addresses: update_item.addresses,
        corporate_info: update_item.corporate_info,
        bank_account: update_item.bank_account,
        phones: update_item.phones,
        comment: update_item.comment,
      }
    });
  },

  updateToDelete(update_item){
    return http.delete(`/suppliers/${update_item}`);
  },

}